import { formatDate } from './utils';
import { TruncateWithTooltip } from './tooltip';

const DicomDetailsPopup = ({ props }: any) => {
  const renderDicomDetail = (
    label: string,
    value: string | undefined,
    className?: string
  ) => {
    return (
      <div className="flex gap-5">
        <span className="text-gray-950">{label} : </span>
        <TruncateWithTooltip
          text={value || ''}
          className={`text-gray-700 ${className || ''}`}
        />
      </div>
    );
  };

  const getMetadataValue = () => props?.instances[0]?.metadata;
  const getSeriesMetadata = () => props;
  const metadata = getMetadataValue();
  const studyDateFormatted = metadata?.StudyDate
    ? formatDate(metadata.StudyDate)
    : undefined;

  return (
    <div className="flex flex-col w-[450px] bg-white rounded-xl p-4 overflow-y-auto">
      <div className="text-center text-xl p-10">DICOM Details</div>
      {renderDicomDetail('Study ID', getMetadataValue()?.StudyID)}
      {renderDicomDetail('SOP Type', getMetadataValue()?.SOPType)}
      {renderDicomDetail(
        'Study InstanceUID',
        getMetadataValue()?.StudyInstanceUID,
        'w-[260px] text-ellipsis whitespace-nowrap overflow-hidden'
      )}
      {renderDicomDetail('Study Date', studyDateFormatted)}
      {renderDicomDetail(
        'Series Description',
        getSeriesMetadata()?.SeriesDescription
      )}
      {renderDicomDetail(
        'SeriesInstanceUID',
        getSeriesMetadata()?.SeriesInstanceUID,
        'w-[260px] text-ellipsis whitespace-nowrap overflow-hidden'
      )}
      {renderDicomDetail('Series Number', getSeriesMetadata()?.SeriesNumber)}
      {renderDicomDetail('Image Type', getMetadataValue()?.ImageType)}
      {renderDicomDetail('Slice Thickness', getMetadataValue()?.SliceThickness)}
      {renderDicomDetail('Rows', getMetadataValue()?.Rows)}
      {renderDicomDetail('Columns', getMetadataValue()?.Columns)}
      {renderDicomDetail(
        'Number Of Phase Encoding Steps',
        getMetadataValue()?.NumberOfPhaseEncodingSteps
      )}
      {renderDicomDetail(
        'Institution Name',
        getMetadataValue()?.InstitutionName
      )}
      {renderDicomDetail('Pixel Spacing', getMetadataValue()?.PixelSpacing)}
      {renderDicomDetail('Echo Time', getMetadataValue()?.EchoTime)}
      {renderDicomDetail(
        'Spacing Between Slices',
        getMetadataValue()?.SpacingBetweenSlices
      )}
      {renderDicomDetail(
        'EchoTrain Length',
        getMetadataValue()?.EchoTrainLength
      )}
      {renderDicomDetail(
        'RFEchoTrain Length',
        getMetadataValue()?.RFEchoTrainLength
      )}
      {renderDicomDetail('Repetition Time', getMetadataValue()?.RepetitionTime)}
      {renderDicomDetail('Flip Angle', getMetadataValue()?.FlipAngle)}
      {renderDicomDetail('Inversion Time', getMetadataValue()?.InversionTime)}
      {renderDicomDetail(
        'Gradient EchoTrain Length',
        getMetadataValue()?.GradientEchoTrainLength
      )}
      {renderDicomDetail('Rescale Slope', getMetadataValue()?.RescaleSlope)}
      {renderDicomDetail(
        'Rescale Intercept',
        getMetadataValue()?.RescaleIntercept
      )}
      {renderDicomDetail('Window Center', getMetadataValue()?.WindowCenter)}
      {renderDicomDetail('Window Width', getMetadataValue()?.WindowWidth)}
    </div>
  );
};
export default DicomDetailsPopup;
